import '../ghs-bottom/ghs-bottom';
import '../ghs-logo/ghs-logo';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { CSSResultGroup, html, TemplateResult, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import componentStyles from './ghs-footer.css.lit';
import '../ghs-icon/ghs-icon';
import '../../base/outline-container/outline-container';

/**
 * NOTE light dom targeting of <li> elements necessary to achieve appropriate margin/padding of accordion section items. This was implemented in the story, and must be implemented in the drupal template.
 */

/**
 * The Footer component
 *
 * @element ghs-footer
 */
@customElement('ghs-footer')
export class GhsFooter extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <div class="footer-wrapper">
        <outline-container>
          <footer class="footer">
            <div class="footer-top-supersection">
              <div class="footer-logo-section">
                <div class="footer-brand-logo">
                  ${this.site !== 'BH'
                    ? html` <slot name="footer-brand-logo">
                        <ghs-logo
                          logo-variant="ghsLogoWhite"
                          site=${this.site}
                        ></ghs-logo>
                      </slot>`
                    : nothing}
                </div>
                <div class="footer-contact">
                  <slot name="footer-contact"></slot>
                </div>
                <div class="footer-social-icons">
                  <slot name="footer-social-icons"></slot>
                </div>
              </div>

              <slot name="footer-menu-section"></slot>
            </div>

            <hr class="footer-great-divide-hr" />

            <div class="footer-disclaimer-et-al-section">
              <div class="footer-et-al-left">
                <div class="footer-links">
                  <slot name="footer-links"></slot>
                </div>
                <div class="footer-copyright">
                  <slot name="footer-copyright"></slot>
                </div>
              </div>
              <div class="footer-btt">
                <ghs-bottom site=${this.site}></ghs-bottom>
              </div>
            </div>
          </footer>
        </outline-container>
      </div>
    `;
  }
}
